import { jsx as _jsx } from "react/jsx-runtime";
const NotFound = () => {
    return (_jsx("div", { style: { padding: 24 }, children: _jsx("h2", { children: "Page not found" }) }));
};
export default NotFound;
